export default __webpack_public_path__ + "static/media/ETH-WHT.086f1626.svg";